//@ts-nocheck
import * as React from 'react';
//@ts-ignore
import { Button, Steps, Upload, message, Row, Col, Modal, Progress } from '@cloud/atom-ui';
import { UploadOutlined, MinusCircleFilled } from '@cloud/atom-ui-icons';
//@ts-ignore
import  '../style.m.less';
import * as nls from '../nls';
import { handleExcel } from './HandleExcel';
import SelectPersonUrl from '@src/configs/web.config';
import { addPermission, transferExcelDataToPermissionData } from '../utils/permisson';
//@ts-ignore
import {i18n} from '@src/utils/i18n';
//@ts-ignore
import lang from '@src/utils/lang';
const language = lang.lang;
const I18N = i18n(nls);
const t = (key)=>{
  return I18N[key];
 };
export default (props) => {
  const { importListVisible, setImportListVisible, reFeshData, appTag } = props;
  const [hasfailed, sethasfailed] = React.useState(false);
  const [allFailed, setAllFailed] = React.useState(false);
  const [hasImport, setHasImport] = React.useState(false);
  const [progressPercent, setProgressPercent] = React.useState(0);
  const [fileList, setFileList] = React.useState([]);
  const [errorFileString, setErrorFileString] = React.useState(``);
  const [inportBtnLoading, setInportBtnLoading] = React.useState(false);
  const [resInfo, setResInfo] = React.useState({ all: 0, successNum: 0, duplicateNum: 0, errorNum: 0 });

  // 取消导入
  const handleImportCancel = (e) => {
    setHasImport(false);
    setImportListVisible(false);
  };

  const toAddPermissionByExcel = (inputData) => {
    setProgressPercent(70);
    // @ts-ignore
    addPermission('excel', transferExcelDataToPermissionData(appTag, inputData)).then(
      (data: { code; message; data }) => {
        setAllFailed(false);
        sethasfailed(false);
        if (data.code === 200) {
          setProgressPercent(90);
          let tmpInfo = {
            all: data.data.successNum + data.data.duplicateNum + data.data.errorNum,
            successNum: data.data.successNum,
            duplicateNum: data.data.duplicateNum,
            errorNum: data.data.errorNum,
          };
          if (data.data.successNum === 0 && data.data.duplicateNum === 0) {
            setErrorFileString(data.data.fileBase64Str);
            setResInfo(tmpInfo);
            setAllFailed(true);
            sethasfailed(true);
          } else if (data.data.errorNum === 0) {
            setResInfo(tmpInfo);
          } else {
            setErrorFileString(data.data.fileBase64Str);
            setResInfo(tmpInfo);
            sethasfailed(true);
          }
          setProgressPercent(100);
          reFeshData();
          setInportBtnLoading(false);
        } else {
          setHasImport(false);
          reFeshData();
          setInportBtnLoading(false);
        }
      },
    );
  };

  // 处理导入 先处理excel 将数据交给后端  将返回的数据同步到SelectList 目前直接用前端处理的数据做测试
  const handleImportOk = (e) => {
    setProgressPercent(10);
    setHasImport(true);
    setInportBtnLoading(true);
    handleExcel(fileList, t).then(
      (data: any) => {
        setProgressPercent(20);
        let tempData = [];
        data.forEach((member) => {
          member.forEach((item) => {
            tempData.push(item);
          });
        });
        setProgressPercent(50);
        if (tempData.length > 500) {
          setProgressPercent(100);
          setHasImport(false);
          message.error(t('ImportTips'), 1);
          setInportBtnLoading(false);
        } else {
          toAddPermissionByExcel(tempData);
        }
      },
      (errorMessage) => {
        setHasImport(false);
        reFeshData();
        setInportBtnLoading(false);
        message.error(errorMessage);
      },
    );
  };

  return (
    // @ts-ignore
    <Modal
      wrapClassName="medium-modal"
      title={t('ImportPersonList')}
      visible={importListVisible}
      onOk={handleImportOk}
      onCancel={handleImportCancel}
      footer={[
        <div className={"modalFooter"} key={'tips'}>
          <span className={"btnTitle"} style={{ textAlign: 'left' }}>
            {t('TipsImport')}
          </span>
          <div>
            <Button
              key="submit"
              type="primary"
              size={'small'}
              style={{ fontSize: 14 }}
              onClick={(e) => handleImportOk(e)}
              loading={inportBtnLoading}
              disabled={fileList.length === 0}
            >
              {t('Import')}
            </Button>
            <Button key="close" size={'small'} style={{ fontSize: 14 }} onClick={(e) => handleImportCancel(e)}>
              {t('Close')}
            </Button>
          </div>
        </div>,
      ]}
    >
      {/* @ts-ignore */}
      <Steps direction="vertical" size={'small'} status="wait">
        <Steps.Step
          icon={
            <div className={"circle"}>
              <div className={"circle_text"}>1</div>
            </div>
          }
          description={
            <>
              <span style={{ color: '#3b3b3b' }}>{t('ImportTips')}</span>
              <a
                href={`${SelectPersonUrl.visiblecopeUrl.getPermisson}s/template/download?${
                  language === 'en' ? 'language=en' : 'language=zh'
                }`}
                download
              >
                {t('DownLoadProfile')}
              </a>
            </>
          }
        />
        <Steps.Step
          icon={
            <div className={"circle"}>
              <div className={"circle_text"}>2</div>
            </div>
          }
          description={
            <UploadComponent
              hasImport={hasImport}
              hasfailed={hasfailed}
              allFailed={allFailed}
              fileList={fileList}
              setFileList={setFileList}
              errorFileString={errorFileString}
              resInfo={resInfo}
              progressPercent={progressPercent}
            ></UploadComponent>
          }
        />
      </Steps>
    </Modal>
  );
};

const UploadComponent = (props) => {
  const { hasImport, hasfailed, fileList, setFileList, allFailed, errorFileString, resInfo, progressPercent } = props;

  const fileListOnchange = (info) => {
    if (info.file?.status !== 'uploading') {
      let tmpFileName = info.file.name;
      let tmpFileClass = tmpFileName.slice(tmpFileName.length - 4, tmpFileName.length);
      if (tmpFileClass === 'xlsx') {
        setFileList(info.fileList);
      } else {
        message.error(t('ErrorTipsIncorrect'));
        let tmpList = info.fileList;
        tmpList.pop();
        setFileList(tmpList);
      }
    }
  };

  const upLoadIinfo = {
    name: 'file',
    action: '',
    headers: { authorization: 'authorization-text' },
    onChange(info) {
      fileListOnchange(info);
    },
    beforeUpload: (file) => false,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    showUploadList: false,
  };

  const upLoadIinfoShow = {
    onChange(info) {
      fileListOnchange(info);
    },
    beforeUpload: (file) => false,
    showUploadList: {
      showRemoveIcon: true,
      removeIcon: <MinusCircleFilled style={{ color: '#ff8870' }} />,
    },
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
  };

  const downloadRes = (data) => {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = URL.createObjectURL(dataUrlToBlob(data));
    link.setAttribute('download', 'Import_Result.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const dataUrlToBlob = (dataUrl) => {
    let byteString = Buffer.from(dataUrl, 'base64');
    return new Blob([byteString], { type: 'application/vnd.ms-excel;charset=utf-8;' });
  };

  return (
    <div>
      <span style={{ color: '#3b3b3b' }}>{t('ImportFile')}</span>
      <div style={{ width: '420px' }}>
        <Row style={{ marginTop: '10px' }}>
          <Col span={18}>
            <div
              className={"uploadArea"}
              style={fileList.length === 0 ? { cursor: 'not-allowed', height: '35px' } : {}}
            >
              <Upload {...upLoadIinfoShow} fileList={fileList} disabled={fileList.length === 0}>
                {fileList.length === 0 ? (
                  <span style={{ marginLeft: '5px', color: 'gray' }}>{t('PleaseSelectFile')}</span>
                ) : (
                  ''
                )}
              </Upload>
            </div>
          </Col>
          <Col span={6}>
            <Upload {...upLoadIinfo} fileList={fileList}>
              <Button icon={<UploadOutlined />}>
                {fileList.length === 0 ? t('SelectFile') : t('ContinueUploading')}
              </Button>
            </Upload>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: '10px', fontSize: '10px', height: '22px', width: '420px' }}>
        {hasImport === false ? (
          <span style={{ color: '#3b3b3b' }}>{t('TipsReWrite')}</span>
        ) : (
          <>
            {progressPercent !== 100 && (
              <Progress percent={progressPercent} status="active" strokeColor="#0d94ff" style={{ marginTop: '10px' }} />
            )}
            {allFailed ? (
              <span style={{ color: '#ff8a72' }}>
                {t('Imported')}
                {t('Failed')}{' '}
              </span>
            ) : (
              <span style={{ color: '#3b3b3b' }}>
                {language === 'en'
                  ? `Imported: ${resInfo.all}; succeeded: ${resInfo.successNum}; duplicate: ${resInfo.duplicateNum};`
                  : `导入${resInfo.all}条，成功${resInfo.successNum}条，重复${resInfo.duplicateNum}条`}
              </span>
            )}
            {hasfailed && (
              <>
                {!allFailed && (
                  <span style={{ color: '#ff8a72' }}>
                    {language === 'en' ? `Failed:${resInfo.errorNum}, ` : `失败${resInfo.errorNum}条，`}
                  </span>
                )}
                <span style={{ color: '#3b3b3b' }}>{t('YouCan')}</span>
                <Button
                  type="link"
                  style={{ fontSize: 12, padding: 0, height: 14 }}
                  onClick={() => {
                    downloadRes(errorFileString);
                  }}
                >
                  {t('DownLoadDetailList')}
                </Button>
                <span style={{ color: '#3b3b3b' }}>{t('ModifyUpload')}</span>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
